export const parseYandexURL = (url, parser) => {
  const partnerId = parser.query.partn || 0;
  const category = parser.query.comp || 0;
  const refererId = parser.query.partner_id || 0;
  return [partnerId, category, refererId];
};
